<template>
  <div class="s3">
    <div v-for="item in items" :key="item.id" @click="goPageWID('case',item.id)">
      <div class="s3_p p1_url" v-bind:style="{'background-image':item.dataImg}">
        <div class="s3_des">{{item.title}}</div>
      </div>
    </div>
    <!-- <div class="s3_p p2_url">
      <div class="s3_des">维保服务(MA)</div>
    </div>
    <div class="s3_p p3_url">
      <div class="s3_des">运维服务(MS)</div>
    </div> -->
  </div>
</template>

<script>
import { apiUrl, baseUrl } from '@/config/config'
const axios = require('axios');
export default {
  data(){
    return{
      items:[],
      iid:null,
    }
  },
  created(){
    
  },
  props:['id'],
  watch:{
    id:{ 
        handler(newVal,oldVal){ 
            console.log(newVal)
            this.iid = newVal; 
            if(newVal) {//如果数据变化则重新创建数据用于渲染 
              this.getMTList();//处理数据 
            } 
        }, 
        immediate:true,//immediate:true代表如果在 wacth 里声明了之后，就会立即先去执行里面的                    
        deep:true//deep，默认值是 false，代表是否深度监听。 
    } 
  },
  methods:{
    goPageWID(name,index){
        this.isShow = false;
        this.$router.push({
            name: name,
            query: { id: index },
        });
    },
    getMTList(){
      let queryId = null;
      switch(this.iid) {
          case 1:
              queryId = 10
              break;
          case 2:
              queryId = 15
              break;
          case 3:
              queryId = 8
              break;
          case 4:
              queryId = 16
              break;
          case 5:
              queryId = 11
              break;
          case 6:
              queryId = 13
              break;
          case 7:
              queryId = 14
              break;
          case 8:
              queryId = 12
              break;
          default:
              queryId = 9
      } 
      axios.get(apiUrl+'/industry/info/find/all?industryId='+queryId).then(res=>{
          this.items = res.data.data;
          for(let i =0;i<this.items.length;i++){
            this.items[i].dataImg = "url("+baseUrl+"upload//"+this.items[i].dataImg+")";
            //console.log(this.items[i])
          }
      })
    },
  }
};
</script>

<style scoped>
.s3{
    width: 750px;
    background: #FFFFFF;
    padding: 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.s3_p{
    width: 694px;
    height: 420px;
    background: #FFFFFF;
    border-radius: 2px;
    margin: 20px 0;
    background-color: cadetblue;
    display: flex;
    flex-direction: column-reverse;
}
.s3_des{
    width: 694px;
    height: 100px;
    background: rgba(16, 28, 54, 0.95);  
    font-size: 30px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 100px;
    text-align: center;
}
.p1_url{
  /* background-image: url("../../static/solution/01.png"); */
  background-size: 694px 420px;
}
.p2_url{
  background-image: url("../../static/solution/02.png");
  background-size: 694px 420px;
}
.p3_url{
  background-image: url("../../static/solution/03.png");
  background-size: 694px 420px;
}
</style>